import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
	AUTH_TOKEN,
	AUTH_ID_USER,
	AUTH_USERNAME,
	AUTH_TIPE,
	AUTH_NAMA,
	AUTH_PENGAWAS_TAGIHAN, AUTH_PENGAWAS_PEKERJAAN, AUTH_KODE_OK_TAGIHAN, AUTH_KODE_OK_PEKERJAAN, AUTH_KODE_OK_RHI
} from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import AuthService from 'services/AuthService';
import {USE_API} from "../../configs/EnvironmentConfig";

import {message, notification} from "antd";
import Cookies from "js-cookie";

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: Cookies.get(AUTH_TOKEN) || null,
	id_user_daftar:localStorage.getItem(AUTH_ID_USER) || null,
	username:localStorage.getItem(AUTH_USERNAME) || null,
	tipe_user:localStorage.getItem(AUTH_TIPE) || null,
	nama:localStorage.getItem(AUTH_NAMA) || null,
    auth_pengawas_tagihan:localStorage.getItem(AUTH_PENGAWAS_TAGIHAN) || null,
    auth_pengawas_pekerjaan:localStorage.getItem(AUTH_PENGAWAS_PEKERJAAN) || null,
	auth_kode_ok_tagihan:localStorage.getItem(AUTH_KODE_OK_TAGIHAN) || '',
	auth_kode_ok_pekerjaan:localStorage.getItem(AUTH_KODE_OK_PEKERJAAN) || '',
	auth_kode_ok_rhi:localStorage.getItem(AUTH_KODE_OK_RHI) || '',
	status_aktivasi:false,
}


export const signIn = createAsyncThunk('auth/login',async (data, { rejectWithValue }) => {
	const { email, password } = data
	try {
		let response;
		response = await AuthService.login({'username':email, password})

		const token = response.token;

		Cookies.set(AUTH_TOKEN, token, {
			expires: 1, // Cookie expires in 7 days
			secure: true, // Only transmitted over HTTPS
			sameSite: 'strict', // Protect against CSRF
			//httpOnly: true,
		});

		localStorage.setItem(AUTH_ID_USER,response.data.id_intra_user);
		localStorage.setItem(AUTH_USERNAME, response.data.username);
		localStorage.setItem(AUTH_TIPE, response.data.nama_tipe);
		localStorage.setItem(AUTH_NAMA, response.data.nama_lengkap);
        localStorage.setItem(AUTH_PENGAWAS_TAGIHAN,response.data.pengawas_tagihan)
        localStorage.setItem(AUTH_PENGAWAS_PEKERJAAN,response.data.pengawas_pekerjaan)
		localStorage.setItem(AUTH_KODE_OK_TAGIHAN,response.data.kode_ok_tagihan);
		localStorage.setItem(AUTH_KODE_OK_PEKERJAAN,response.data.kode_ok_pekerjaan);
		localStorage.setItem(AUTH_KODE_OK_RHI,response.data.kode_ok_rhi);

		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const signUp = createAsyncThunk('auth/register',async (data, { rejectWithValue }) => {
	const { email, password,repeat_password } = data

	try {
		const response = await AuthService.register({email, password,repeat_password})
		// cek respon dr API
		if(response.success!=true){
			return rejectWithValue(response.message || 'Error')
		}else{
			message.success(response.message,3,function () {
				window.location.href = "auth/login";
			});
		}
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})


export const signOut = createAsyncThunk('auth/logout',async () => {
	const response = await AuthService.logout(Cookies.get(AUTH_TOKEN))

	Cookies.remove(AUTH_TOKEN);
	localStorage.removeItem(AUTH_ID_USER);
	localStorage.removeItem(AUTH_USERNAME);
	localStorage.removeItem(AUTH_TIPE);
	localStorage.removeItem(AUTH_NAMA);
    localStorage.removeItem(AUTH_PENGAWAS_TAGIHAN);
    localStorage.removeItem(AUTH_PENGAWAS_PEKERJAAN);
	localStorage.removeItem(AUTH_KODE_OK_TAGIHAN);
	localStorage.removeItem(AUTH_KODE_OK_PEKERJAAN);
	localStorage.removeItem(AUTH_KODE_OK_RHI);

	if(response.success!=true){
		notification.error({
			message: 'Perhatian',
			className:"text-danger",
			description:response.message||'error',
			duration:3
		});
	}

    return response.data
})

export const signInWithGoogle = createAsyncThunk('auth/signInWithGoogle', async (_, { rejectWithValue }) => {
    try {
		const response = await AuthService.loginInOAuth()
		const token = response.data.token;
		localStorage.setItem(AUTH_TOKEN, token);
		return token;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const signInWithFacebook = createAsyncThunk('auth/signInWithFacebook', async (_, { rejectWithValue }) => {
    try {
		const response = await AuthService.loginInOAuth()
		const token = response.data.token;
		localStorage.setItem(AUTH_TOKEN, token);
		return token;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const aktivasi = createAsyncThunk('auth/aktivasi',async (data, { rejectWithValue }) => {
	const {username,token } = data

	try {
		const response = await AuthService.aktivasi({username,token})
		// cek respon dr API
		if(response.success!=true){
			return rejectWithValue(response.message || 'Error')
		}else{
			return response
		}
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})


export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticated: (state, action) => {
			state.loading = false
			state.redirect = '/'
			state.token = action.payload.token
			state.id_user_daftar=action.payload.data.id_intra_user
			state.username=action.payload.data.username
			state.tipe_user=action.payload.data.nama_tipe
			state.nama=action.payload.data.nama_lengkap
            state.auth_pengawas_tagihan=action.payload.data.pengawas_tagihan
            state.auth_pengawas_pekerjaan=action.payload.data.pengawas_pekerjaan
		state.auth_kode_ok_tagihan=action.payload.data.kode_ok_tagihan
		state.auth_kode_ok_pekerjaan=action.payload.data.kode_ok_pekerjaan
		state.auth_kode_ok_rhi=action.payload.data.kode_ok_rhi
	},
	showAuthMessage: (state, action) => {
			state.message = action.payload
			state.showMessage = true
			state.loading = false
		},
		hideAuthMessage: (state) => {
			state.message = ''
			state.showMessage = false
		},
		signOutSuccess: (state) => {
			state.loading = false
			state.token = null
			state.redirect = '/'
		},
		showLoading: (state) => {
			state.loading = true
		},
		signInSuccess: (state, action) => {
			state.loading = false
			state.token = action.payload.token
			state.id_user_daftar=action.payload.data.id_intra_user
			state.username=action.payload.data.username
			state.tipe_user=action.payload.data.nama_tipe
			state.nama=action.payload.data.nama_lengkap
            state.auth_pengawas_tagihan=action.payload.data.pengawas_tagihan
            state.auth_pengawas_pekerjaan=action.payload.data.pengawas_pekerjaan
		state.auth_kode_ok_tagihan=action.payload.data.kode_ok_tagihan
		state.auth_kode_ok_pekerjaan=action.payload.data.kode_ok_pekerjaan
		state.auth_kode_ok_rhi=action.payload.data.kode_ok_rhi
	}
	},
	extraReducers: (builder) => {
		builder
			.addCase(signIn.pending, (state) => {
				state.loading = true
			})
			.addCase(signIn.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload.token
				state.id_user_daftar=action.payload.data.id_intra_user
				state.username=action.payload.data.username
				state.tipe_user=action.payload.data.nama_tipe
				state.nama=action.payload.data.nama_lengkap
                state.auth_pengawas_tagihan=action.payload.data.pengawas_tagihan
                state.auth_pengawas_pekerjaan=action.payload.data.pengawas_pekerjaan
			state.auth_kode_ok_tagihan=action.payload.data.kode_ok_tagihan
			state.auth_kode_ok_pekerjaan=action.payload.data.kode_ok_pekerjaan
			state.auth_kode_ok_rhi=action.payload.data.kode_ok_rhi
		})
		.addCase(signIn.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signOut.fulfilled, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signOut.rejected, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signUp.pending, (state) => {
				state.loading = true
			})
			.addCase(signUp.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = ''
				state.token = action.payload
			})
			.addCase(signUp.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signInWithGoogle.pending, (state) => {
				state.loading = true
			})
			.addCase(signInWithGoogle.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signInWithGoogle.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signInWithFacebook.pending, (state) => {
				state.loading = true
			})
			.addCase(signInWithFacebook.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signInWithFacebook.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(aktivasi.pending, (state) => {
				state.loading = true
			})
			.addCase(aktivasi.fulfilled, (state, action) => {
				state.loading = false
				state.status_aktivasi = action.payload.success
				state.message = action.payload.message
			})
			.addCase(aktivasi.rejected, (state, action) => {
				state.status_aktivasi = action.payload.success
				state.loading = false
				state.message = action.payload.message
			})
	},
})

export const {
	authenticated,
	showAuthMessage,
	hideAuthMessage,
	signOutSuccess,
	showLoading,
	signInSuccess
} = authSlice.actions

export default authSlice.reducer
